import { Navigate, Route, Routes } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAppSelector } from './hooks/redux';
import LoginPage from './pages/Login';
import SetPasswordPage from './pages/SetPassword';
import WorkspaceShell from './components/WorkspaceShell';
import AdminCompanies from './pages/admin/Companies';
import CompanyDetail from './pages/admin/CompanyDetail';
import Messages from './pages/admin/Messages';

function RequireAnalyst({ children }: { children: ReactNode }) {
  const { token, user } = useAppSelector((s) => s.auth);
  if (!token || (user && user.role !== 'ADMIN')) return <Navigate to="/login" replace />;
  if (user?.mustChangePassword) return <Navigate to="/set-password" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route
        element={
          <RequireAnalyst>
            <WorkspaceShell />
          </RequireAnalyst>
        }
      >
        <Route path="/" element={<Navigate to="/companies" replace />} />
        <Route path="/companies" element={<AdminCompanies key="all" scope="all" />} />
        <Route path="/companies/:id" element={<CompanyDetail />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/my-companies" element={<Navigate to="/companies" replace />} />
        <Route path="/verification" element={<Navigate to="/companies" replace />} />
        <Route path="/ratings" element={<Navigate to="/companies" replace />} />
        <Route path="/remediation" element={<Navigate to="/companies" replace />} />
        <Route path="/outreach" element={<Navigate to="/companies" replace />} />
        <Route path="/team" element={<Navigate to="/companies" replace />} />
        <Route path="/account" element={<Navigate to="/companies" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
